import { render } from "./AppointmentDetailsModal.vue?vue&type=template&id=4c3f8ed7&scoped=true"
import script from "./AppointmentDetailsModal.vue?vue&type=script&lang=js"
export * from "./AppointmentDetailsModal.vue?vue&type=script&lang=js"

import "./AppointmentDetailsModal.vue?vue&type=style&index=0&id=4c3f8ed7&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c3f8ed7"]])

export default __exports__